<template>
  <div>
    <h2 class="txt-center">페이지를 불러오는 중입니다...</h2>
    <waitModal :isShow="wait.isWaitModalShow" :pWait="wait" :pTime="time" :pTotalCount="durationCount"></waitModal>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import waitModal from "@/components/login/waitModal.vue";
export default {
  data: () => ({
    id: "",
    accesscode: "",
    pageIdx: 0,
    item_email: "@airport.kr",
    infoMessage: "", // Notice 내용
    item_email: "", // 관리자단- 신청자정보에서 이메일 등록한 주소값
    logo: "", // 회사 로고 url
    main: "", // 메인 배경 url
    pageIdx: "", // 페이지 idx (itm_main_page_idx와 같음)
    pointColor: "Blue", // 메뉴와 버튼 색깔
    qaAdmin: "", // hq 매니저
    qaAdminInfo: "", // hq 매니저 정보
    sugangStartDate: "2020-01-01 00:00", // 수강신청 시작 날짜
    sugangEndDate: "2020-12-30 00:00", // 수강신청 종료 날짜
    title: "", // 프로그램명 타이틀
    ds: "",
    wait: {
      isWaitModalShow: false,
      isJoin: false,
      count: 0,
      currentCount: 0,
      firstCount: 0,
      totalTime: 0,
      totalCount: 0,
      time: 0,
    },
    time: 0,
    changeTotalTime: 0,
    socket_state: false,
    socekt_status: false,

    durationCount: 0,
  }),
  components: {
    waitModal,
  },
  mounted() {
    if (location.href.indexOf("apply2") !== -1) {
      const me = this;
      // console.log("socket")
      // console.log(window.socket);
      // console.log(window.socket.io._readyState);
      // setTimeout(()=>{
      // console.log("io");
      // console.log(window.socket.connected);
      // if(window.socket.io._readyState == 'open' ){

      if (window.socket.io._readyState.indexOf("open") != -1) {
        window.socket.emit("join");
        window.socket.on("apply", (res) => {
          // me.socekt_status = true;
          // console.log("apply");
          me.wait = res;
          if (me.wait.isJoin) {
            me.pageInit();
            //    return false;
          }
          // console.log(me.wait);
          let members = res.members;
          const finedItem = members.find(function (item) {
            return item.waitCount === me.wait.currentCount;
          });
          const count = members.indexOf(finedItem);

          // console.log("apply count :"  + count);
          me.wait.count = count;
          me.wait.totalCount = count;
          me.wait.durationCount = count;
          me.wait.totalTime = res.totalTime * count;
        });

        window.socket.on("waitTime", (res) => {
          // console.log(res);
          let today = new Date();
          // console.log(today);
          me.wait.firstCount = res.firstCount;
          let members = res.members;
          const finedItem = members.find(function (item) {
            return item.waitCount === me.wait.currentCount;
          });
          const count = members.indexOf(finedItem);
          me.wait.count = count;
          this.durationCount = count;
          this.time = this.wait.totalTime - res.time * count;
          // console.log("waititme");
          // console.log(this.time)
        });
      } else {
        me.pageInit();
      }
      // },100)
    } else {
      this.pageInit();
    }
  },
  methods: {
    timer(duration) {
      const me = this;
      let timerinter = null;
      setInterval(() => {
        let du = duration - 1000;
        me.msToTime(du);
      }, 1000);
    },
    msToTime(duration) {
      var milliseconds = parseInt((duration % 1000) / 100),
        seconds = parseInt((duration / 1000) % 60),
        minutes = parseInt((duration / (1000 * 60)) % 60),
        hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      this.wait.hours = hours;
      this.wait.min = minutes;
      this.wait.sec = seconds;
    },

    pageInit() {
      LogRocket.init("inchon/inchon");
      /**
       * init
       */
      sessionStorage.removeItem("b2b_kname");
      sessionStorage.removeItem("b2b_sabun");
      sessionStorage.removeItem("b2b_mobile");
      sessionStorage.removeItem("b2b_email");
      sessionStorage.removeItem("callup");
      sessionStorage.removeItem("iiacoff_view");
      sessionStorage.removeItem("is_read");
      this.id = this.$route.query.id;
      this.accesscode = this.$route.query.accesscode;
      this.ds = this.$route.query.ds;

      if(this.$route.query.loginPageMode){
        //로그인으로 이동한 다음, 신청내역확인 탭이 열리도록 함.
        sessionStorage.setItem("loginPageMode", this.$route.query.loginPageMode);
      }else{
        sessionStorage.setItem("loginPageMode", "");
      }
      if (this.$route.path == "/lnk/iiacon") {
        sessionStorage.setItem("iiacoff_view", "Y");
        sessionStorage.setItem("is_read", "Y");
      }

      if (this.$route.path == "/lnk/carrot2021" || this.$route.path == "/lnk/iiacoff1" || this.$route.path == "/lnk/iiacon2" || this.$route.path == "/lnk/iiacoff2") {
        sessionStorage.setItem("is_read", "Y");
      }

      if (typeof this.ds != "undefined") {
        var dsDecode = "";
        if (this.$route.path == "/lnk/carrot1121") {
          dsDecode = decodeURIComponent(atob(this.ds));
        } else {
          dsDecode = atob(this.ds);
        }
        this.ds = JSON.parse(dsDecode);
        var emailId = this.ds.b2b_email.split("@")[0];
        if (typeof this.ds.b2b_email == "undefined") {
          sessionStorage.setItem("b2b_email", "");
        } else {
          sessionStorage.setItem("b2b_email", emailId);
        }
        if (typeof this.ds.b2b_kname == "undefined") {
          sessionStorage.setItem("b2b_kname", "");
        } else {
          sessionStorage.setItem("b2b_kname", this.ds.b2b_kname);
        }
        if (typeof this.ds.b2b_mobile == "undefined") {
          sessionStorage.setItem("b2b_mobile", "");
        } else {
          sessionStorage.setItem("b2b_mobile", this.ds.b2b_mobile);
        }

        if (typeof this.ds.b2b_sabun == "undefined") {
          sessionStorage.setItem("b2b_sabun", "");
        } else {
          sessionStorage.setItem("b2b_sabun", this.ds.b2b_sabun);
        }
        if (typeof this.ds.callup == "undefined") {
          sessionStorage.setItem("callup", "");
        } else {
          sessionStorage.setItem("callup", this.ds.callup);
        }

        //
      } else {
        this.ds = new Array();
      }

      if (typeof this.id == "undefined") {
        this.id = this.ds.b2b_sabun;
      }

      LogRocket.identify(this.ds.id);
      sessionStorage.setItem("companyCode", this.$route.params.companyCode);
      localStorage.setItem("companyCode", this.$route.params.companyCode);

      if (typeof this.id != "undefined" && this.$route.path != "/lnk/busanedu"){
        // this.id 값이 존재하고, busanedu 가 아닌경우 읽기전용모드로 동작한다.
        sessionStorage.setItem("is_read", "Y");
      }

      if (typeof this.id == "undefined") {
        this.$router.push("/user/login");
        localStorage.setItem("is_num", "N");
      } else {
        let params = new URLSearchParams();
        localStorage.setItem("is_num", "Y");
        params.append("companyCode", this.$route.params.companyCode);
        this.axios.get(this.axios.root + this.axios.port + `/user/main/${this.$route.params.companyCode}`, params).then((res) => {
          this.isLoading = false;
          if (res.data.err === 0) {
            for (var item of Object.keys(res.data)) {
              if (typeof this[item] !== "undefined") {
                this[item] = res.data[item];
                // 배경 이미지 변경
                if (item === "pageIdx") {
                  sessionStorage.setItem("pageIdx", res.data[item]);
                }
              }
            }

            sessionStorage.setItem("pointColor", res.data.pointColor);

            var params = new URLSearchParams();

            params.append("accessCode", this.accesscode);
            params.append("id", this.ds.b2b_email);
            params.append("pageIdx", this.pageIdx);
            params.append("login_password", this.login_password);

            this.axios.post(this.axios.root + this.axios.port + "/login/page", params).then((res) => {
              if (res.data.err === 0) {
                this.isValidAccess = true;
                localStorage.setItem("accessToken", res.data.accessToken);
                localStorage.setItem("userId", this.id);
                this.axios.defaults.headers.common["accessToken"] = res.data.accessToken;
                sessionStorage.setItem("mainIdx", res.data.main.idx);
                sessionStorage.setItem("pageIdx", res.data.main.idx_itm_sugang_page_main);
                sessionStorage.setItem("logo", this.logo);
                sessionStorage.setItem("mainTitle", this.title);
                sessionStorage.setItem("qaAdminInfo", this.qaAdminInfo);
                sessionStorage.setItem("cancle_YN", res.data.main.cancle_YN);
                sessionStorage.setItem("partial_pay", res.data.main.partial_pay);
                sessionStorage.setItem("program_dup_YN", res.data.main.program_dup_YN);
                this.fetchProcessData();
              } else if (res.data.err === 105) {
                alert("정확한 Access Code를 입력해 주세요.");
                this.isValidAccess = false;
                return false;
              } else {
                alert(res.data.result);
                this.isValidAccess = false;
                return false;
              }
            });
          } else if (res.data.err === 105) {
            sessionStorage.setItem("onlySearch", "Y");
            alert("신청 기간이 아닙니다. \n신청이 종료된 후 1년이 지나지 않았을 시에는\n신청내역 확인에서 신청한 내역들을 확인할 수 있습니다.");
          } else if (res.data.err === 900) {
            if (sessionStorage.getItem("isAdmin")) {
              for (var item of Object.keys(res.data)) {
                if (typeof this[item] !== "undefined") {
                  this[item] = res.data[item];
                  // 배경 이미지 변경
                  if (item === "main") {
                    document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                    document.getElementById("login-main").style["background-size"] = "cover";
                  }

                  if (item === "pageIdx") {
                    sessionStorage.setItem("pageIdx", res.data[item]);
                  }
                }
              }
              sessionStorage.setItem("pointColor", res.data.pointColor);
            } else {
              for (var item of Object.keys(res.data)) {
                if (typeof this[item] !== "undefined") {
                  this[item] = res.data[item];
                  if (item === "pageIdx") {
                    sessionStorage.setItem("pageIdx", res.data[item]);
                  }
                }
              }

              sessionStorage.setItem("pointColor", res.data.pointColor);
              alert("신청 기간이 아닙니다.");
            }
          } else if (res.data.err === 901) {
            if (sessionStorage.getItem("isAdmin")) {
              for (var item of Object.keys(res.data)) {
                if (typeof this[item] !== "undefined") {
                  this[item] = res.data[item];

                  if (item === "pageIdx") {
                    sessionStorage.setItem("pageIdx", res.data[item]);
                  }
                }
              }
              sessionStorage.setItem("pointColor", res.data.pointColor);
            } else {
              sessionStorage.setItem("onlySearch", "Y");
              for (var item of Object.keys(res.data)) {
                if (typeof this[item] !== "undefined") {
                  // 변수로 지정한 값만 데이터 들어가게 지정
                  this[item] = res.data[item];

                  if (item === "pageIdx") {
                    sessionStorage.setItem("pageIdx", res.data[item]);
                  }
                }
              }

              sessionStorage.setItem("pointColor", res.data.pointColor);

              this.$router.push("/user/login");
            }
          } else if (res.data.err === 902) {
            if (sessionStorage.getItem("isAdmin")) {
              for (var item of Object.keys(res.data)) {
                if (typeof this[item] !== "undefined") {
                  this[item] = res.data[item];

                  if (item === "pageIdx") {
                    sessionStorage.setItem("pageIdx", res.data[item]);
                  }
                }
              }

              sessionStorage.setItem("pointColor", res.data.pointColor);

            } else {
              for (var item of Object.keys(res.data)) {
                if (typeof this[item] !== "undefined") {
                  this[item] = res.data[item];
                  // 배경 이미지 변경
                  if (item === "main") {
                    document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                    document.getElementById("login-main").style["background-size"] = "cover";
                  }

                  if (item === "pageIdx") {
                    sessionStorage.setItem("pageIdx", res.data[item]);
                  }
                }
              }

              sessionStorage.setItem("pointColor", res.data.pointColor);
              sessionStorage.setItem("onlySearch", "Y");
              alert("신청 기간이 아닙니다.");
            }
          }
        });
      }
    },

    fetchProcessData() {
      var params = {
        pageIdx: this.pageIdx,
      };

      this.axios
        .get(this.axios.root + this.axios.port + `/user/select-program/${this.pageIdx}`, {
          params: params,
        })
        .then((res) => {
          // console.log('res', res)
          if (res.data.err === 0) {
            var program_types = [];
            for (var item of res.data.programList) {
              program_types.push({
                program_type: item.program_type,
                program_name: item.program_name,
                programIdx: item.idx,
              });
            }

            // 해당 수강신청의 프로그램 타입 종류 저장
            sessionStorage.setItem("program_types", JSON.stringify(program_types));
            // alert('인증 완료')
            this.$router.push("/user/reg/init");
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          // console.log(err)
          alert(err);
        });
    },
  },
};
</script>
